
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const FETCH_START = 'FETCH_START';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';



export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS";
export const SAVE_AUTH_DETAILS = "SAVE_AUTH_DETAILS";


export const BANNER_INFO = "BANNER_INFO";
export const LOCATION_INFO = "LOCATION_INFO";
export const STANDARD_PROGRAMMS = "STANDARD_PROGRAMMS";

export const UPDATE_EVENT_LIST = "UPDATE_EVENT_LIST";
export const UPDATE_USERS_LIST = "UPDATE_USERS_LIST";
export const UPDATE_EVENT_AVAILABILITY = "UPDATE_EVENT_AVAILABILITY";
export const UPDATE_PENDING_POSTS = "UPDATE_PENDING_POSTS";
export const UPDATE_EVENT_DETAILS = "UPDATE_EVENT_DETAILS";
export const SET_BOOKING_EVENT = "SET_BOOKING_EVENT";
export const SET_BOOKING_RESPONSE = "SET_BOOKING_RESPONSE";
export const SET_BOOKING_CONFIRMATION = "SET_BOOKING_CONFIRMATION";

export const GET_REJECTED_POSTS = "GET_REJECTED_POSTS";
export const GET_ALL_POSTS = "GET_ALL_POSTS";

export const GET_PROFILE_INFO = "GET_PROFILE_INFO";
export const SAVE_PROFILE_INFO = "SAVE_PROFILE_INFO";
export const SAVE_MY_BOOKING = "SAVE_MY_BOOKING";
export const SHOW_MODAL = "SHOW_MODAL";
export const ADD_NEWSLETTER = "ADD_NEWSLETTER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_BOOKING_INFO = "UPDATE_BOOKING_INFO";

export const IMAGE_UPLOAD_FINISHED = "IMAGE_UPLOAD_FINISHED";

export const SET_CHANGED_PASSWORD = "SET_CHANGED_PASSWORD";

export const SET_UPLOADED_IMAGE = "SET_UPLOADED_IMAGE";

export const SET_EVENT_TO_EDIT = "SET_EVENT_TO_EDIT";

export const SET_EVENT_TEMPLATE = "SET_EVENT_TEMPLATE";

export const CLEAR_IMAGE = "CLEAR_IMAGE";
export const SET_UPDATED_EVENT = "SET_UPDATED_EVENT";

export const SAVE_DASHBOARD_INFO = "SAVE_DASHBOARD_INFO";

export const SAVE_ALL_COUPONS = "SAVE_ALL_COUPONS";
export const ADD_ALL_COUPONS = "ADD_ALL_COUPONS";

export const CLEAR_EVENT_STATE = "CLEAR_EVENT_STATE";

export const SAVE_BOOKING_DETAILS = "SAVE_BOOKING_DETAILS";

export const SAVE_INVOICE_DETAILS = "SAVE_INVOICE_DETAILS";

export const SET_CONTACT_LIST = "SET_CONTACT_LIST";

export const SET_CURRENT_POSTS = "SET_CURRENT_POSTS";

